import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";

export default function WebNumeracyGraph({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [scoreCount, setScoreCount] = useState(data.scoreCount);
    const [availableChoices, setAvailableChoices] = useState(data.choices);
    const [answer, setAnswer] = useState({})

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setScoreCount(data.scoreCount);
        setAvailableChoices(data.choices);
        setAnswer([]);
    }, [question,
        data.scoreCount,
        data.choices,
    ]);

    const handleSelectChoice = (key, value) => {
        let ans = {};
        ans[key] = value;
        const newAnswer = { ...answer, ...ans };
        setAnswer(newAnswer);
        checkCanProceed(newAnswer);
    }

    const checkCanProceed = (ans) => {
        const answerKeys = Object.keys(ans);

        let canProceed = false;
        answerKeys.map((keys) => {
            if (ans[keys] !== "" && ans[keys] !== null) {
                canProceed = true;
            }
            return null;
        })

        onAnswer({
            canProceed,
            answer: ans,
        })
    }

    return (
        <Box
            sx={{
                position: "relative",
                textAlign: "center",
            }}
        >
            <Box component="img" src={`${imagesResources}${data.image}`} />
            <Box sx={{
                position: "absolute",
                top: "31px",
                left: data.tableStyle.left,
                display: "flex",
                width: data.tableStyle.width,
                height: "305px",
                justifyContent: "space-between",
                overflowY: "hidden",
                textAlign: "center"
            }}>
                {availableChoices.map((choice, index) => {
                    return (
                        <Box key={index} 
                            sx={{
                                flexDirection: "column",
                                display: "flex",
                                textAlign: "center"
                            }
                        }>
                            {[...Array(scoreCount)].map((_, index) => {
                                return (
                                    <Box key={index} 
                                        component="span"
                                        style={{
                                            position: "relative",
                                            height: "37px",
                                            width: "70px",
                                            opacity: answer[choice.stateKey] === scoreCount - index ? "1" : "0",
                                            borderBottom: "medium",
                                            backgroundColor: "transparent",
                                            zIndex: "0",
                                            display: "inline-table",
                                            cursor: "pointer",
                                            userSelect: "none",
                                            fontWeight: "bold",
                                            textAlign: "center",
                                        }}
                                        onClick={() => handleSelectChoice(choice.stateKey, scoreCount - index)}
                                    >
                                        <Box component="span"
                                            style={{
                                                display: "table-cell",
                                                verticalAlign: "middle",
                                                cursor: "pointer",
                                                fontWeight: "bold",
                                                textAlign: "center",
                                            }}
                                        >
                                            <Box sx={{
                                                position: "absolute",
                                                top: "6px",
                                                backgroundColor: "rgb(65, 142, 150)",
                                                height: "400px",
                                                width: "70px",
                                                pointerEvents: "none",
                                                cursor: "pointer",
                                                fontWeight: "bold",
                                                textAlign: "center",
                                            }}>
                                            </Box>
                                            <Box sx={{
                                                position: "absolute",
                                                top: "0px",
                                                left: "26px",
                                                backgroundColor: "rgb(141, 208, 81)",
                                                height: "12px",
                                                width: "12px",
                                                borderRadius: "6px",
                                                border: "1px solid rgb(73, 183, 93)",
                                                cursor: "pointer",
                                                fontWeight: "bold",
                                                textAlign: "center",
                                            }}>
                                            </Box>
                                        </Box>
                                    </Box>
                                )
                            })}
                        </Box>
                    )
                })}
            </Box>
        </Box>
    );
};
